var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ maxWidth: '100%' }),attrs:{"id":"app"}},[_c('global-header'),_c('router-view',{attrs:{"scWidth":_vm.width}}),_c('global-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }